export default __webpack_public_path__ + "static/media/1.63538f11.svg";